module.exports = __webpack_public_path__ + "img/_successful.de0fb68f.svg";